import React from 'react'
import resolveProps from '../../../utils/resolveProps'
import { CardProps, TypesProps } from './types'
import useCard from './useCard'

const CardWithTypes = withType(CardContent)

function withType<T>(Component: React.ComponentType<T>) {
  const CardWithCurrentType = (props: T) => {
    const { currentCard, config } = useCard(Object.keys(props))
    // if (loading) return <div>carregando...</div>
    return <Component {...props} cardName={currentCard} config={config} />
  }

  return CardWithCurrentType
}

function CardContent(props) {
  const {
    className,
    inverse,
    icon,
    children,
    imgSrc = '',
    image,
    alt = '',
    imgAlt = '',
    video,
    videoSrc,
    videoAlt,
    loading,
    cardName,
    config,
    institutional,
    product,
    retail,
    ...rest
  } = props

  return !loading ? (
    <div className={`${resolveProps(props, config, cardName?.name)} `}  {...rest}>
      {!!imgSrc && (
        <div className={`mdn-${cardName?.name}--imageThumb`}>
          <img src={imgSrc} alt={alt || imgAlt} />
        </div>
      )}
      {!!videoSrc && (
        <div className={`mdn-${cardName?.name}--imageThumb`}>
          <img src={videoSrc} alt={videoAlt} />
        </div>
      )}
      {!!icon && (
        <span
          className={`mdn-${cardName?.name}-icon mdn-Icon--lg mdn-Icon-${icon}`}
          aria-hidden="false"
        ></span>
      )}
      <div className={`mdn-${cardName?.name}-content`}>{children}</div>
    </div>
  ) : (
    <div className={"mdn-Skeleton"} aria-busy={true}>
      {(image || video) ? (
        <div className="mdn-CardInstitutional mdn-CardInstitutional--image">
        <div className="mdn-CardInstitutional--imageThumb">
          <div className="mdn-Skeleton-item mdn-Skeleton-image"></div>
        </div>
        <div className="mdn-CardInstitutional-content">
          <div className="mdn-Skeleton-item mdn-Skeleton-title mdn-Heading mdn-Heading--lg">&nbsp;</div>
          <p className="mdn-Skeleton-item mdn-Skeleton-text"></p>
          <p className="mdn-Skeleton-item mdn-Skeleton-text"></p>
          <p className="mdn-Skeleton-item mdn-Skeleton-text"></p>
          <p className="mdn-Skeleton-item mdn-Skeleton-text"></p>
          <p className="mdn-Skeleton-item mdn-Skeleton-text"></p>
          <p className="mdn-Skeleton-item mdn-Skeleton-text"></p>
          <p className="mdn-Skeleton-item mdn-Skeleton-text"></p>
          <p className="mdn-Skeleton-item mdn-Skeleton-text"></p>
          <div className="mdn-Skeleton-item mdn-Skeleton-button"></div>
        </div>
      </div>
      ) : (
        <div className={`mdn-CardInstitutional ${inverse ? 'mdn-CardInstitutional--inverse' : 'mdn-CardInstitutional--default'}`}>
        <span className="mdn-Skeleton-item mdn-Skeleton-icon mdn-CardInstitutional-icon" aria-hidden="true"></span>
        <div className="mdn-CardInstitutional-content">
          <div className="mdn-Skeleton-item mdn-Skeleton-title mdn-Heading mdn-Heading--lg">&nbsp;</div>
          <p className="mdn-Skeleton-item mdn-Skeleton-text"></p>
          <p className="mdn-Skeleton-item mdn-Skeleton-text"></p>
          <p className="mdn-Skeleton-item mdn-Skeleton-text"></p>
          <p className="mdn-Skeleton-item mdn-Skeleton-text"></p>
          <p className="mdn-Skeleton-item mdn-Skeleton-text"></p>
          <p className="mdn-Skeleton-item mdn-Skeleton-text"></p>
          <div className="mdn-Skeleton-item mdn-Skeleton-button"></div>
        </div>
      </div>
      )}

    </div>
  )
}

const Card = (props: CardProps & TypesProps) => {
  return <CardWithTypes {...props} />
}

export default Card
